module.exports = __webpack_public_path__ + "img/survey.22d4ecc3.png";